export const defaultData = {};

const legendConfig = [
  { color: "#95DE64", label: "Passed Checks", toggled: true, key: 'comply', sort: 0 },
  { color: "#95DE64", label: "Verified Comply", toggled: true, key: 'positiveVerified' },
  { color: "#95DE64", label: "Verified Comply", toggled: true, key: 'verifiedComply' },
  { color: "#b7c54a", label: "Unverified Comply", toggled: true, key: 'positiveUnVerified' },
  { color: "#b7c54a", label: "Unverified Comply", toggled: true, key: 'unverifiedComply' },

  { color: "#FF4D4F", label: "Failed Checks", toggled: true, key: 'gap', sort: 2 },
  { color: "#FF4D4F", label: "Verified Gap", toggled: true, key: 'gapVerified' },
  { color: "#FF4D4F", label: "Verified Gap", toggled: true, key: 'verifiedGap' },
  { color: "#fd7d28", label: "Unverified Gap", toggled: true, key: 'gapUnVerified' },
  { color: "#fd7d28", label: "Unverified Gap", toggled: true, key: 'unverifiedGap' },

  { color: "#CCCCCC", label: "Not Applicable", toggled: true, key: 'null', sort: 3 },
  { color: "#FEC84B", label: "Undetermined", toggled: true, key: 'undetermined', sort: 1 },
  { color: "#9DC68A", label: "Unverified Checks", toggled: true, key: 'unverified' },

  { color: "#FFD8DA", label: "Contested Outcome", toggled: true, key: 'contested' },
  { color: "#CCCCCC", label: "Undetermined Subject", toggled: true, key: 'undeterminedSubject' },
];

export const getLegend = (data = {}) => {
  const availableKeys = Object.values(data).reduce((all, v) => {
    const keys = Object.keys(v).filter(k => !all.includes(k));
    return [...all, ...keys];
  }, []);
  if (availableKeys.length) {
    return legendConfig.filter((l) => availableKeys.includes(l.key));
  }
  return [];
}

export const Tooltip = (Data, t) => {
  const data = [...Data];
  const allValues = data.map((d) => d.value);
  let sum = 0;
  // data.reverse();

  allValues.forEach((v) => {
    sum += parseInt(v) || 0;
  });

  const items = data.map((d) => {
    const name = legendConfig.find((l) => l.key === d.name).label;
    return `
      <div class="item">
        <div class="cont">
          <div class="legend" style="background: ${d.color}"></div>
        </div>
        <div class="cont label">
          <label>${t(name)}</label>
        </div>
        <div class="cont value">
          <label>${d.value}</label>
        </div>
      </div>
    `;
  });

  if (data) {
    return `
      <div class="sca-graph-tooltip">
        <div class="tooltip-header">
          <h3>Version ${data[0] ? data[0].title.split('v')[1] : ''}</h3>
          <h4>${t('Checks')}: ${sum}</h4>
        </div>
        <div class="items">
          ${items.join('')}  
        </div>
      </div>
    `;
  }
  return '';
};

const DEFAULT_POINTS = 60;

export const mapData = (data, metricsValues = []) => {
  const all = [];
  const values = Object.entries(data);

  const add = (k, v) => {
    metricsValues.forEach((m) => {
      if (m.toggled) {
        all.push({
          type: `v${k}`,
          value: v[m.key] || 0,
          series: m.key,
        });
      }
    });
  };

  switch (values.length) {
    case 1:
      const [k, v] = values[0];
      for (let i = (DEFAULT_POINTS * -1); i < 1; i++) {
        add(`${i}_`, v);
      }
      add(k, v, k);
      for (let i = 2; i < (DEFAULT_POINTS + 6); i++) {
        add(`${i}_`, v);
      }
      break;
    default:
      // let _points = parseInt(DEFAULT_POINTS / values.length);
      // _points = Number.isNaN(_points) || !_points ? 0 : _points === 10 ? 11 : _points;
      let _points = 0;

      values.forEach(([k, v], i) => {
        if (i === 0) {
          for (let j = 0; j < _points + 1; j++) {
            metricsValues.forEach((m) => {
              if (m.toggled) {
                all.push({
                  type: `_v${k}${j}`,
                  value: v[m.key] || 0,
                  series: m.key,
                });
              }
            });
          }
        }

        metricsValues.forEach((m) => {
          if (m.toggled) {
            all.push({ type: `v${k}`, value: v[m.key] || 0, series: m.key });
          }
        });


        if (i === values.length - 1) {
          for (let j = 0; j < _points + 1; j++) {
            metricsValues.forEach((m) => {
              if (m.toggled) {
                all.push({
                  type: `_v${k}${j}`,
                  value: v[m.key] || 0,
                  series: m.key,
                });
              }
            });
          }
        } else {
          const _next = values[i + 1];
          if (_next) {
            metricsValues.forEach((m) => {
              if (m.toggled) {
                const _first = typeof _next[1][m.key] === 'number' ? _next[1][m.key] : 0;
                const _second = typeof v[m.key] === 'number' ? v[m.key] : 0;
                let _diff = (_first - _second) / (_points + 1);
                _diff = Number.isNaN(_diff) ? 0 : _diff;

                for (let j = 1; j <= _points; j++) {
                  all.push({
                    type: `_v${k}${i}${j}`,
                    value: (v[m.key] || 0) + (_diff * j),
                    series: m.key,
                  });
                }
              }
            });
          }
        }
      });
  }
  return all;
};

export const addVirtualPoints = ({ startValue = 0, values, initValue, lastValue, startFromZero = true, series }) => {
  const items = [];
  if (startFromZero) {
    const incrVal = (lastValue - initValue) / values;
    for (let i = 0; i < values; i++) {
      items.push({
        type: `_${startValue}`,
        dontShow: true,
        value: 0 + (incrVal * i),
        series,
        // type: values[0].series
      });
      startValue++;
    }
    return items;
  } else {
    const incrVal = (lastValue - initValue) / (values + 1);
    for (let i = 0; i < values; i++) {
      items.push({
        type: `_${startValue}`,
        dontShow: true,
        value: initValue + (incrVal * i),
        series,
        // type: values[0].series
      });
      startValue++;
    }
  }
  return items;
};

export const oneCase = ({ versions, length, series }) => {
  const items = []
  const item = versions[0];
  const _values = Math.round(length);
  const values = _values <= 0 ? 0 : _values;

  const before = addVirtualPoints({
    startValue: 0,
    values,
    lastValue: item.value || 0,
    initValue: item.value || 0,
    startFromZero: false,
    series,
  });
  const after = addVirtualPoints({
    startValue: values,
    values,
    lastValue: item.value || 0,
    initValue: item.value || 0,
    startFromZero: false,
    series,
  });
  items.push(...before);
  items.push({
    values: item.value || 0,
    type: item.type,
    series,
  });
  items.push(...after);
  return items;
};

export const middleCase = ({ versions, value, series }) => {
  const items = [];
  const firstItem = versions[0];
  const before = addVirtualPoints({
    startValue: 0,
    values: value,
    lastValue: firstItem.value || 0,
    initValue: firstItem.value || 0,
    startFromZero: false,
    series,
  });
  items.push(...before);
  for (let i = 0; i < versions.length; i++) {
    const item = versions[i];
    items.push({
      value: item.value || 0,
      type: item.type,
      series,
    });
    let toPush = [];
    if (i === versions.length - 1) {
      toPush = addVirtualPoints({
        startValue: value + (i * value),
        series,
        values: value,
        lastValue: item.value || 0,
        initValue: item.value || 0,
        startFromZero: false,
      });
    } else {
      toPush = addVirtualPoints({
        series,
        startValue: value + (i * value),
        values: value,
        lastValue: versions[i + 1].value || 0,
        initValue: item.value || 0,
        startFromZero: false,
      });
    }
    items.push(...toPush);
  }
  return items;
};
